import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { animateScroll as scroll, scroller, Element } from 'react-scroll'; // eslint-disable-line

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import WebIcon from '@material-ui/icons/Web';
import ShareIcon from '@material-ui/icons/Share';
import errorIcon from '../../static/img/icons/warning_icon.svg';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import MySnackbarContentWrapper from '../../shared/snackbars/MySnackbarContentWrapper';
import profilePlaceholder from '../../static/img/profile_placeholder.png';
import FacebookIcon from '../../static/img/icons/facebook.png';
import TwitterIcon from '../../static/img/icons/twitter.png';
import InstagramIcon from '../../static/img/icons/instagram.png';
import SkypeIcon from '../../static/img/icons/skype.png';
import ClassListItem from './ClassesListItem';

import { getUserProfile } from '../../shared/requests/UserInfoRequests';
import { getTrainerProfile } from '../../shared/requests/TrainerRequests';
import { getUserCerts } from '../../shared/requests/UserCertsRequests';

import ShareDialog from '../ShareDialog';
import { constructShareLink, truncate, buildYouTubeEmbed } from '../../shared/Helpers';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(4))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  loadingSpinner: {
    margin: theme.spacing(5),
    justifyContent: 'center',
  },
  certImg: {
    margin: theme.spacing(0.2),
    height: 34,
    width: 34,
  },
  teacherHeader: {
    fontSize: 18,
    marginBottom: theme.spacing(),
    letterSpacing: '1px',
    textTransform: 'uppercase',
    [theme.breakpoints.down(600)]: {
      textAlign: 'center',
    },
  },
  smallIcon: {
    verticalAlign: 'text-bottom',
    color: 'black',
    height: 18,
    width: 18,
    marginRight: theme.spacing(),
  },
  expansionPanel: {
    boxShadow: 'none',
    '&:before': {
      left: 'inherit',
    },
  },
  expansionPanelSummary: {
    flexDirection: 'column',
    padding: 0,
  },
  gridContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up(800 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
    },
  },
  teacherName: {
    fontWeight: 400,
    fontSize: 32,
    letterSpacing: '1px',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    textTransform: 'uppercase',
    [theme.breakpoints.down(600)]: {
      paddingTop: 0,
      textAlign: 'center',
    },
  },
  certList: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  teacherLinks: {
  },
  teacherLink: {
    fontSize: 14,
    padding: theme.spacing(),
    wordBreak: 'break-all',
  },
  buttonContainer: {
    display: 'flex',
    paddingTop: theme.spacing(3),
  },
  button: {
    marginRight: theme.spacing(2),
  },
  extLinks: {
    color: 'rgba(0, 0, 0, 0.54)',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  icon: {
    height: '40px',
    width: '40px',
    marginRight: theme.spacing(),
  },
  flexRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  profileImg: {
    height: '200px',
    width: '200px',
    [theme.breakpoints.up(600)]: {
      height: '160px',
      width: '160px',
    },
    [theme.breakpoints.up(740)]: {
      height: '200px',
      width: '200px',
    },
    margin: '0 auto',
  },
  paddedText: {
    padding: theme.spacing(2),
  },
  gridPadding: {
    padding: theme.spacing(3),
  },
  borderRight: {
    [theme.breakpoints.up(600)]: {
      borderRight: '1px solid rgba(0, 0, 0, 0.2)',
    },
  },
  h3: {
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    fontSize: 14,
    marginBottom: theme.spacing(),
  },
  mediaDiv: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  trainerBlurb: {
    padding: theme.spacing(2),
    fontStyle: 'italic',
  },
});

class ProfilePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userStatus: '',
      expanded: '',
      user: {},
      loading: true,
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
      listOpen: false,
      certs: [],
      certsLoading: true,
      niaclasses: [],
      shareDialogOpen: false,
      trainerProfile: false,
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleListToggle = this.handleListToggle.bind(this);
    this.handleShareDialogOpen = this.handleShareDialogOpen.bind(this);
    this.handleShareDialogClose = this.handleShareDialogClose.bind(this);
  }

  componentDidMount() {
    const { userNameOrId } = this.props.match.params;
    // Try to get user info by user name
    let userStatus, snackbarOpen, snackbarVariant, snackbarMessage;
    getUserProfile(userNameOrId)
      .then((response) => {
        console.log('got user profile: ', response.data);
        // get certs
        getUserCerts(response.data.id)
          .then((response2) => {
            // console.log('got user certs: ', response.data);
            this.setState({
              certs: response2.data,
              certsLoading: false,
            });
          })
          .catch((error2) => {
            console.log('failed to get user certs');
            console.log(error2.response);
            this.setState({
              snackbarOpen: true,
              snackbarVariant: 'error',
              snackbarMessage: 'Failed to load Certifications',
            });
          });
        if (response.data.userInfo.is_trainer) {
          getTrainerProfile(response.data.id)
            .then((response3) => {
              console.log('got trainer profile: ', response3.data);
              this.setState({
                trainerProfile: response3.data,
              });
            })
            .catch((error3) => {
              console.log('failed to get trainer profile');
              console.log(error3.response);
            });
        }

        // attach locations to classes
        const niaclasses = [];
        response.data.classes.forEach((niaclass) => {
          if (niaclass.attendance_type === 'online') {
            niaclasses.push(niaclass);
          } else {
            response.data.locations.forEach((location) => {
              const newclass = niaclass;
              if (niaclass.location === location.id) {
                newclass.location = location;
                niaclasses.push(newclass);
              }
            });
          }
        });
        this.setState({
          userStatus: 'found',
          user: response.data,
          niaclasses,
          loading: false,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            userStatus = 'private';
            snackbarOpen = false;
          } else if (error.response.status === 404) {
            userStatus = 'notFound';
            snackbarOpen = true;
            snackbarVariant = 'error';
            snackbarMessage = 'User Does Not Exist';
          } else {
            userStatus = 'notFound';
            snackbarOpen = true;
            snackbarVariant = 'error';
            snackbarMessage = 'Something Went Wrong';
          }
        } else {
          userStatus = 'notFound';
          snackbarOpen = true;
          snackbarVariant = 'error';
          snackbarMessage = 'Something Went Wrong';
        }
        this.setState({
          userStatus,
          snackbarOpen,
          snackbarVariant,
          snackbarMessage,
          loading: false,
        });
      });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  handleChange(panel) {
    const { expanded } = this.state;
    const isExpanded = expanded === panel ? false : panel;
    this.setState({ expanded: isExpanded });
  }

  handleListToggle() {
    const { listOpen } = this.state;
    this.setState({ listOpen: !listOpen });
    if (!listOpen) {
      scroller.scrollTo('scrolltoclasslist', {
        duration: 200,
        delay: 100,
        smooth: true,
        offset: -80,
      });
    }
  }

  handleShareDialogOpen() {
    this.setState({ shareDialogOpen: true });
  }

  handleShareDialogClose() {
    this.setState({ shareDialogOpen: false });
  }

  handleCopy(link) {
    navigator.clipboard.writeText(link);
    this.setState({
      snackbarOpen: true,
      snackbarMessage: 'Link Copied',
      snackbarVariant: 'success',
    });
  }

  render() {
    const { classes, location } = this.props;
    const {
      userStatus,
      expanded,
      user,
      loading,
      snackbarVariant,
      snackbarMessage,
      snackbarOpen,
      listOpen,
      certs,
      certsLoading,
      niaclasses,
      shareDialogOpen,
      trainerProfile,
    } = this.state;

    // Default profile image if not found
    let profileImg = profilePlaceholder;
    if (user.userInfo) {
      profileImg = user.userInfo.profile_img || profilePlaceholder;
    }

    // Construct social: necessary to deal with people that already had https: in their handles
    function constructSocialUrl(social) {
      return social.startsWith('https://') ? social : `https://${social}`;
    }

    // function constructSocialDisplay(social) {
    //   return social.startsWith('https://') ? social.replace('https://', '') : social;
    // }

    return (
      <div className={classes.page}>
        <NavBar />
        <main className={classes.container}>
          <div className={classes.appBarSpacer} />
          <Typography color="textSecondary" className={classes.header} variant="h4">Profile</Typography>
          <Paper className={classes.paper}>
            {loading
              ? <CircularProgress color="secondary" className={classes.loadingSpinner} />
              : (
                <Grid container className={classes.gridContainer}>

                  <Helmet>
                    <title>{user.first_name + ' ' + user.last_name + ' | Nia Teacher Profile'}</title>
                    <meta name="description" content={user.userInfo ? truncate(user.userInfo.description, 200) : 'private profile'} />
                    <meta name="keywords" content={user.first_name + ',' + user.last_name + ', teacher, profile'} />
                  </Helmet>

                  {userStatus === 'notFound'
                    && (
                      <Grid item xs={12} sm={8} className={classes.gridPadding}>
                        <div className={classes.errorContainer}>
                          <img src={errorIcon} alt="error icon" className={classes.icon} />
                          <Typography color="secondary" variant="h6" className={classes.paddedText}>
                            We are having trouble finding that user...
                          </Typography>
                        </div>
                      </Grid>
                    )}
                  {userStatus === 'private'
                    && (
                      <Grid item xs={12} sm={8} className={classes.gridPadding}>
                        <div className={classes.errorContainer}>
                          <img src={errorIcon} alt="error icon" className={classes.icon} />
                          <Typography color="secondary" variant="h6" className={classes.paddedText}>
                            This account is set to private.
                          </Typography>
                        </div>
                      </Grid>
                    )}
                  {userStatus === 'found'
                    && (
                      <React.Fragment>
                        {/* PROFILE IMG */}
                        <Grid item xs={12} sm={4} className={classes.gridPadding}>
                          <Avatar
                            className={classes.profileImg}
                            src={profileImg}
                            title="Profle Picture"
                          />
                        </Grid>
                        <Grid item xs={12} sm={8} className={classes.gridPadding}>
                          {/* NAME */}
                          <Typography className={classes.teacherName} variant="h2">
                            {`${user.first_name} ${user.last_name}`}
                          </Typography>
                          {/* TEACHER/TRAINER */}
                          <Typography variant="h3" color="textSecondary" className={classes.teacherHeader}>{'Teacher ' + (user.userInfo.is_trainer ? '| Trainer' : '')}</Typography>
                          {/* CERTS */}
                          {!certsLoading && (
                            <div className={classes.certList}>
                              {certs.map((cert) => {
                                if (cert.cert_level.img) {
                                  return (
                                    <Tooltip key={cert.id} title={cert.cert_level.level}>
                                      <img src={cert.cert_level.img} alt="" className={classes.certImg} />
                                    </Tooltip>
                                  );
                                }
                                return null;
                              })}
                            </div>
                          )}
                          <div className={classes.buttonContainer}>
                            {listOpen
                              ? (
                                <Button onClick={this.handleListToggle} disabled={Object.keys(user.classes).length === 0} className={classes.button} variant="outlined" color="secondary">Hide Classes</Button>
                              )
                              : (
                                <Button onClick={this.handleListToggle} disabled={Object.keys(user.classes).length === 0} className={classes.button} variant="outlined" color="secondary">My Classes</Button>
                              )
                            }
                            {user.userInfo.is_trainer && <Button className={classes.button} variant="outlined" color="secondary" href={'/finder/training/?trainer=' + encodeURIComponent(user.first_name + ' ' + user.last_name)}>My Trainings</Button>}
                            <Button variant="outlined" color="secondary" onClick={this.handleShareDialogOpen} endIcon={<ShareIcon />}>Share</Button>
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider />
                        </Grid>
                        <Grid item xs={12} sm={4} className={classNames(classes.gridPadding, classes.borderRight)}>
                          {/* LINKS */}
                          <Typography variant="h3" color="textSecondary" className={classes.h3}>Contact Info</Typography>
                          <div className={classes.teacherLinks}>
                            {user.userInfo.contact_email && (
                              <Typography className={classes.teacherLink} color="textSecondary">
                                <EmailIcon className={classes.smallIcon} style={{ color: 'red' }} />
                                <a className={classes.extLinks} href={`mailto:${' ' + user.userInfo.contact_email}?subject=I saw your profile on NiaNow.com!`}>{user.userInfo.contact_email}</a>
                              </Typography>
                            )}
                            {user.userInfo.mobile_phone && ( // Comes from Contact Phone field on edit profile page
                              <Typography className={classes.teacherLink} color="textSecondary">
                                <PhoneIcon className={classes.smallIcon} style={{ color: 'red' }} />
                                {user.userInfo.mobile_phone}
                              </Typography>
                            )}
                            {user.userInfo.website && (
                              <Typography className={classes.teacherLink} color="textSecondary">
                                <WebIcon className={classes.smallIcon} style={{ color: 'red' }} />
                                <a className={classes.extLinks} target="_blank" rel="noopener noreferrer" href={constructSocialUrl(user.userInfo.website)}>Website</a>
                              </Typography>
                            )}
                            {user.userInfo.instagram && (
                              <Typography className={classes.teacherLink} color="textSecondary">
                                <img src={InstagramIcon} alt="instagram icon" className={classes.smallIcon} />
                                <a className={classes.extLinks} target="_blank" rel="noopener noreferrer" href={constructSocialUrl(user.userInfo.instagram)}>Instagram</a>
                              </Typography>
                            )}
                            {user.userInfo.facebook && (
                              <Typography className={classes.teacherLink} color="textSecondary">
                                <img src={FacebookIcon} alt="facebook icon" className={classes.smallIcon} />
                                <a className={classes.extLinks} target="_blank" rel="noopener noreferrer" href={constructSocialUrl(user.userInfo.facebook)}>Facebook</a>
                              </Typography>
                            )}
                            {user.userInfo.twitter && (
                              <Typography className={classes.teacherLink} color="textSecondary">
                                <img src={TwitterIcon} alt="twitter icon" className={classes.smallIcon} />
                                <a className={classes.extLinks} target="_blank" rel="noopener noreferrer" href={constructSocialUrl(user.userInfo.twitter)}>Twitter</a>
                              </Typography>
                            )}
                            {user.userInfo.skype && (
                              <Typography className={classes.teacherLink} color="textSecondary">
                                <img src={SkypeIcon} alt="skype icon" className={classes.smallIcon} />
                                {user.userInfo.skype}
                              </Typography>
                            )}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={8} className={classes.gridPadding}>
                          {trainerProfile && trainerProfile.description !== '' && <Typography color="textSecondary" className={classes.trainerBlurb}>{trainerProfile.description}</Typography>}
                          {/* MEDIA */}
                          {user.userInfo.profile_vid && (
                            <div className={classes.mediaDiv}>
                              <Typography variant="h3" color="textSecondary" className={classes.h3}>Media</Typography>
                              <iframe
                                title={user.first_name + ' ' + user.last_name + ' '}
                                src={buildYouTubeEmbed(user.userInfo.profile_vid)}
                                className={classes.video}
                                frameBorder="0"
                                allow="autoplay; fullscreen"
                              />
                            </div>
                          )}
                          {/* DESCRIPTION */}
                          {user.userInfo.description
                            && (
                              <Accordion className={classes.expansionPanel} expanded={expanded === 'panel1'} onChange={() => this.handleChange('panel1')}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  classes={{
                                    content: classes.expansionPanelSummary,
                                  }}
                                >
                                  <Typography variant="h3" color="textSecondary" className={classes.h3}>About Me</Typography>
                                  {expanded !== 'panel1'
                                    && (
                                      <Typography>{truncate(user.userInfo.description, 150)}</Typography>
                                    )
                                  }
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Typography className={classes.expansionSubheading}>{user.userInfo.description}</Typography>
                                </AccordionDetails>
                              </Accordion>
                            )
                          }
                          {/* TEACHING INFO */}
                          {user.userInfo.teaching_info
                            && (
                              <Accordion className={classes.expansionPanel} expanded={expanded === 'panel2'} onChange={() => this.handleChange('panel2')}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  classes={{
                                    content: classes.expansionPanelSummary,
                                  }}
                                >
                                  <Typography variant="h3" color="textSecondary" className={classes.h3}>About My Classes</Typography>
                                  {expanded !== 'panel2'
                                    && (
                                      <Typography>{truncate(user.userInfo.teaching_info, 150)}</Typography>
                                    )
                                  }
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Typography className={classes.expansionSubheading}>{user.userInfo.teaching_info}</Typography>
                                </AccordionDetails>
                              </Accordion>
                            )
                          }
                        </Grid>
                      </React.Fragment>
                    )}
                </Grid>
              )}
          </Paper>
          {niaclasses.length > 0 && (
            <Element className={classNames('element', classes.classList)} name="scrolltoclasslist">
              {!loading && listOpen && (
                <React.Fragment>
                  {niaclasses.map(c => (
                    <ClassListItem
                      key={c.id}
                      user={user}
                      currentClass={c}
                      classTimezone={c.timezone}
                    />
                  ))}
                </React.Fragment>
              )}
            </Element>
          )}
          {/* SHARE DIALOG */}
          <ShareDialog
            open={shareDialogOpen}
            link={constructShareLink(location)}
            handleCopy={() => this.handleCopy(constructShareLink(location))}
            handleClose={this.handleShareDialogClose}
          />
          {/* SNACKBAR */}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={snackbarOpen}
            autoHideDuration={5000}
            onClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              onClose={this.handleClose}
              variant={snackbarVariant}
              message={snackbarMessage}
            />
          </Snackbar>
          <FooterSpacer />
        </main>
        <Footer />
      </div>
    );
  }
}

ProfilePage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProfilePage);
